/* Native-details reveal and explicit clipboard action. No cart, checkout, cookies or tracking changes. */
if (!customElements.get('ys-halloween-treat')) {
  customElements.define('ys-halloween-treat', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.pending) return;
      this.pending = true;
      queueMicrotask(() => {
        this.pending = false;
        if (!this.isConnected || this.controller) return;
        const button = this.querySelector('[data-hw-copy]');
        const codeElement = this.querySelector('[data-hw-code]');
        const status = this.querySelector('[data-hw-status]');
        if (!button || !codeElement || !status || !this.dataset.code) return;
        this.controller = new AbortController();
        this.busy = false;
        this.addEventListener('keydown', event => {
          const ticket = this.querySelector('details');
          if (event.key !== 'Escape' || !ticket?.open) return;
          event.preventDefault();
          ticket.open = false;
          ticket.querySelector('summary')?.focus({ preventScroll: true });
        }, { signal: this.controller.signal });
        button.addEventListener('click', async () => {
          if (this.busy) return;
          this.busy = true;
          button.setAttribute('aria-busy', 'true');
          let copied = false;
          try {
            if (navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(this.dataset.code);
              copied = true;
            }
          } catch { /* Permission denied: try the gesture-bound local fallback. */ }
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = this.dataset.code;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
            this.append(field);
            field.select();
            try { copied = document.execCommand('copy'); } catch { copied = false; }
            field.remove();
          }
          this.busy = false;
          button.removeAttribute('aria-busy');
          if (!this.isConnected) return;
          button.textContent = copied ? this.dataset.copiedLabel : this.dataset.copyLabel;
          status.textContent = copied ? 'Copied. Five featured individual products only; T5 and bundles excluded.' : this.dataset.manualLabel;
          if (!copied) {
            const range = document.createRange();
            range.selectNodeContents(codeElement);
            const selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
          }
          button.focus({ preventScroll: true });
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            if (this.isConnected) button.textContent = this.dataset.copyLabel;
          }, 2500);
        }, { signal: this.controller.signal });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.resetTimer);
    }
  });
}
